import { Injectable } from '@angular/core';
import { VisitedAtMap } from '../../models/profile.model';
import { ConnectService } from '../connect/connect.service';
import { ProfileService } from '../profile/profile.service';

export interface OnBoardingContent {
  terms_condition_summary: string;
  terms_condition: string;
  privacy_policy: string;
  disclaimer: string;
  welcome_letter: string;
  contact_information: string;
}

export enum OnboardingScreens {
  welcome_letter_accepted_at,
  terms_condition_accepted_at,
  disclaimer_accepted_at,
  dob_verification_accepted_at,
}

const OnboardingRoutes = ['welcome', 'terms-security', 'disclaimer', 'birth-date-verification'] as const;

const OnboardingRouteMap = {
  welcome: OnboardingScreens.welcome_letter_accepted_at,
  'terms-security': OnboardingScreens.terms_condition_accepted_at,
  disclaimer: OnboardingScreens.disclaimer_accepted_at,
  'birth-date-verification': OnboardingScreens.dob_verification_accepted_at,
};

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private get visitedAtMap(): VisitedAtMap {
    return this.profile.profile;
  }

  private dobVerificationRequired = false;

  constructor(private connectService: ConnectService, private profile: ProfileService) {}

  getNextRoute(currentScreen?: OnboardingScreens) {
    let skipScreens = currentScreen != null;
    return (
      OnboardingRoutes.find(route => {
        const screen = OnboardingRouteMap[route];

        // skip until current screen matched
        if (screen === currentScreen) {
          skipScreens = false;
          return false;
        } else if (skipScreens) {
          return false;
        }

        const screenName = OnboardingScreens[screen];
        const visitedAt = this.visitedAtMap[screenName];

        // skip visited screens
        if (visitedAt != null) {
          return false;
        }

        // ignore dob verification if not required
        return !(screen === OnboardingRouteMap['birth-date-verification'] && !this.dobVerificationRequired);
      }) || null
    );
  }

  isNavigateBack(currentUrl: string, nextUrl: string): boolean {
    const santitize = s => {
      return s.replace(/\//g, '');
    };
    const currentUrlIdx = OnboardingRoutes.indexOf(santitize(currentUrl));
    const nextUrlIdx = OnboardingRoutes.indexOf(santitize(nextUrl));
    return nextUrlIdx < currentUrlIdx && currentUrlIdx >= 0 && nextUrlIdx >= 0;
  }

  async setVisitAt(screen: OnboardingScreens) {
    const visitedAt = new Date().toJSON();
    const screenName = OnboardingScreens[screen];

    this.profile.profile = { ...this.profile.profile, [screenName]: visitedAt };
    this.connectService
      .update('/accounts/profile', null, {
        account: {
          [screenName]: new Date().toJSON(),
        },
      })
      .subscribe({
        error: this.connectService.handleError,
      });
  }

  setDOBVerificationRequired(val: boolean) {
    this.dobVerificationRequired = val && !!this.profile.profile.date_of_birth;
  }
}
